import { render, staticRenderFns } from "./ModalCreateGES.vue?vue&type=template&id=21925abc"
import script from "./ModalCreateGES.vue?vue&type=script&lang=js"
export * from "./ModalCreateGES.vue?vue&type=script&lang=js"
import style0 from "./ModalCreateGES.vue?vue&type=style&index=0&id=21925abc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports